import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { EditRounded } from "@mui/icons-material";
import { AdminToggle, DataTableColumn, TagChip } from "../../../components/ui";
import PlanModel from "../../../models/plan.model";
import { daysOptions } from "./plans-options";

type Options = {
    onEdit: (plan: PlanModel) => void;
    onToggle: (plan: PlanModel) => void;
};

/** Colunas da tabela de planos (Plano / Preço / Período / Status / Ações). */
export function buildPlanColumns({ onEdit, onToggle }: Options): DataTableColumn<PlanModel>[] {
    return [
        {
            key: "name",
            header: "Plano",
            width: "2fr",
            render: (row) => <Typography sx={{ fontSize: 14, fontWeight: 600, color: "text.primary" }}>{row.name}</Typography>,
        },
        {
            key: "value",
            header: "Preço (R$)",
            width: "1.2fr",
            render: (row) => (
                <Typography sx={{ fontSize: 14, color: "text.primary" }}>
                    {(row.value ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                </Typography>
            ),
        },
        {
            key: "daysOfUse",
            header: "Período",
            width: "1fr",
            render: (row) => {
                const match = daysOptions.find((o) => o.value === String(row.daysOfUse));
                return <TagChip label={match ? match.label : `${row.daysOfUse ?? "—"} dias`} maxChars={20} />;
            },
        },
        {
            key: "status",
            header: "Status",
            width: "1.2fr",
            render: (row) => <AdminToggle checked={!!row.enabled} onChange={() => onToggle(row)} label={row.enabled ? "Habilitado" : "Desabilitado"} />,
        },
        {
            key: "actions",
            header: "Ações",
            width: "100px",
            align: "right",
            render: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <Tooltip title="Editar plano" placement="top">
                        <IconButton
                            size="small"
                            aria-label="Editar plano"
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit(row);
                            }}
                            sx={{ borderRadius: "8px" }}
                        >
                            <EditRounded sx={{ fontSize: 17 }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            ),
        },
    ];
}
